import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-step-senha',
  templateUrl: './step-senha.component.html',
  styleUrls: ['./step-senha.component.scss']
})
export class StepSenhaComponent implements OnChanges  {
  senha = '';
  isCasasBahia = location.href.indexOf('casasbahia') > 0 || location.href.indexOf('-cb') > 0;
  isMinorThanTablet: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 1024px)');

  @Input()
  loading = false;

  @Input()
  nomeCliente = '';

  @Input()
  networkError: string | null = null;

  @Output()
  continuar: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  forgotPassword: EventEmitter<void> = new EventEmitter<void>();

  fieldsWithFocus = [];

  showPassword = false;

  @ViewChild('form') form: NgForm;

  constructor(
    private router: Router,
    private breakpointObserver: BreakpointObserver,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.networkError?.currentValue || this.networkError) {
      setTimeout(() => {
        this.form.controls.inputPassword.markAllAsTouched();
        this.form.controls.inputPassword.setErrors({ networkError: true });
      });
    }
  }


  handleContinuar(e: any) {
    e.preventDefault();
    this.continuar.emit(this.senha);
  }

  get isHlg() {
    return location.href.indexOf('-hlg-') > 0;
  }

  get brandName() {
    return this.isCasasBahia ? 'Casas Bahia' : 'Pontofrio';
  }

  irParaCadastro(): void {
    this.router.navigate(['/cadastro'], { queryParamsHandling: 'preserve' });
  }

  irParaAlterarSenha(): void {
    this.forgotPassword.emit();
  }
}
